<template>
  <b-modal
    id="modal-change-name"
    ref="modal-change-name"
    cancel-variant="outline-secondary"
    :ok-title="$t('Save')"
    :cancel-title="$t('Close')"
    centered
    title="ویرایش نام کاربر"
  >
    <b-form>
      <b-form-group
        label="نام فعلی کاربر"
        label-for="device-name"
      >
        <b-form-input
          id="device-name"
          v-model="deviceName"
          disabled
        />
      </b-form-group>

      <b-form-group
        label="نام جدید"
        label-for="new-first-name"
      >
        <b-form-input
          id="new-first-name"
          v-model="newFirstName"
          placeholder="نام جدید را وارد کنید"
          required
        />
      </b-form-group>

      <b-form-group
        label="نام خانوادگی جدید"
        label-for="new-last-name"
      >
        <b-form-input
          id="new-last-name"
          v-model="newLastName"
          placeholder="نام خانوادگی جدید را وارد کنید"
          required
        />
      </b-form-group>
    </b-form>

    <template #modal-footer>
      <b-button
        size="sm"
        variant="danger"
        :disabled="isLoading"
        @click="closeModal"
      >
        بستن
      </b-button>
      <b-button
        size="sm"
        variant="success"
        :disabled="isLoading"
        @click="saveName"
      >
        <b-spinner
          v-if="isLoading"
          small
        /> ذخیره
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BCard, BForm, BCardBody, BButton, BInputGroup, BInputGroupPrepend, BFormCheckbox, BFormSelect, BFormDatalist, BSpinner,
} from 'bootstrap-vue'
import DeviceService from '@/services/device.service'

export default {
  components: {
    BRow,
    BCard,
    BCardBody,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BSpinner,
    BFormCheckbox,
    BFormSelect,
    BFormDatalist,
  },
  props: {
    device: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      newFirstName: '',
      newLastName: '',
      deviceName: '',
      isLoading: false,
    }
  },
  watch: {
    device: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.userName) {
          this.updateFields(newVal)
        }
      },
    },
  },
  methods: {
    updateFields(device) {
      this.deviceName = device.userName || 'نام نامشخص'
      this.newFirstName = device.firstName || ''
      this.newLastName = device.lastName || ''
    },
    async saveName() {
      if (!this.newFirstName.trim() || !this.newLastName.trim()) {
        return
      }
      this.isLoading = true
      try {
        const response = await DeviceService.changeName({
          imei: this.device.imei,
          name: this.newFirstName, // ارسال نام جدید
          family: this.newLastName, // ارسال نام خانوادگی جدید
        })

        this.$emit('save', response)
        this.$bvModal.hide('modal-change-name')
        this.showToast('نام کاربر با موفقیت تغییر یافت', 'success')
      } catch (error) {
        this.showToast('خطایی در تغییر نام رخ داد!', 'danger')
      } finally {
        this.isLoading = false
      }
    },
    showToast(message, variant) {
      this.$bvToast.toast(message, {
        title: variant === 'success' ? '✅ موفقیت' : '❌ خطا',
        variant,
        solid: true,
      })
    },
    closeModal() {
      this.$bvModal.hide('modal-change-name')
    },
  },
}
</script>
